import { muteWithWif, pinWithWif, removeFromPlaylistWithWif } from "helpers/steem";
import React, { useState, useRef, useEffect } from "react";
import { useAuth } from '../helpers/authContext'; 
import { isLoggedWithKeychain } from "services/dsteem-service";
import { muteKeychain, pinKeychain, removeFromPlaylistKeychain } from "helpers/keychain";
import useModal from 'helpers/useModal';
import PlaylistsModal from "features/user/userModals/PlaylistsModal";
import { useToast } from "./ui/use-toast";
import LoginModal from "../features/user/userModals/LoginModal";
import PromoteModal from "features/user/userModals/PromoteModal";

const PostDropdown = ({ isCommunityMod, isPinned,isMuted , communityName, author, permlink, urlType = "p", 
                        canBeDeleted=false, playlistId = "", isExpired = false, lightMode = false }) => { 
    const {user, autologin, updateUserMetadata} = useAuth();
    const [open, setOpen] = useState(false);
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast();
    const [pendingAction, setPendingAction] = useState<null | {
            type: "remove";
            payload: any;
        }>(null);
    const [pinned, setPinned] = useState(isPinned);
    const [muted, setMuted] = useState(isMuted);
    const [pinLoading, setPinLoading] = useState(false);
    // const [colorLabel, setColorLabel] = useState("sky-blue");
    const [muteLoading, setMuteLoading] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null); 
    const { isOpenPlaylistsModal, togglePlaylistsModal, isOpenPromoteModal, togglePromoteModal } = useModal(); 

    const keychainLogin = isLoggedWithKeychain(autologin);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const menuNode = menuRef.current;
            if (menuNode && !menuNode.contains(event.target)) {
                setOpen(false);
            }
        }; 
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handlePin = async () => {
        // if (!user) onLogin();
        setPinLoading(true);
    
        const type = isPinned ? 'unpinPost' : 'pinPost';
        const fn = keychainLogin ? pinKeychain : pinWithWif;
    
        try {
            const result:any = await fn(keychainLogin ? user : autologin, communityName, type, author, permlink );
            console.log(result);
            
            if (result.success) {
                setPinned(!isPinned); 
                setOpen(false);
            } else {
                console.log('Pin operation failed.');
            }
        } catch (err) {
          console.log('Error subscribing: ' + err);
        } finally {
          setPinLoading(false);
        }
    }; 
    const handleMute = async () => {
        // if (!user) onLogin();
        setMuteLoading(true);
    
        const type = muted ? 'unmutePost' : 'mutePost';
        const fn = keychainLogin ? muteKeychain : muteWithWif;
    
        try {
            const result:any = await fn(keychainLogin ? user : autologin, communityName, type, author, permlink );
            console.log(result);
            
            if (result.success) {
                setMuted(!muted); 
                setOpen(false);
            } else {
                console.log('mute operation failed.');
            }
        } catch (err) {
          console.log('Error muting: ' + err);
        } finally {
          setMuteLoading(false);
        }
    }; 
    const handleDeleteFromPlaylist = async (newWif = "") => {
        // if (!user) onLogin();
        if (playlistId) {
            const voteFn = keychainLogin ? removeFromPlaylistKeychain : removeFromPlaylistWithWif;
            const account = keychainLogin ? user : autologin; 
            let res:any = await voteFn(account, playlistId, {author, permlink},newWif);
            if (!res.success) {
                if(res.message.toString().includes("Missing Active Authority")){
                    setPendingAction({
                        type: "remove",
                        payload: { playlistId, author, permlink }
                    });
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                }
                
                toast({
                title:"Failed removing from playlist.",
                description:res.message,
                variant:"rose_red"
                });
            }else {
                toast({
                title:"Item removed successfully.",
                description:"Your changes may take a few minutes to take effect.",
                variant:"wild_green"
                }); 
                updateUserMetadata(); 
            }
        }else{
            toast({
                title:"Failed removing item from playlist.",
                description:"ID is required.",
                variant:"rose_red"
            });
        }
    }; 

    return (
        <>
            <div className={`post-menu ${lightMode ? "post-menu-light" : ""} ${open ? "menu-open" : ""}`} ref={menuRef} style={{ display: "flex", alignItems: "center", zIndex: open ? 2001 : 997 }}>
                
                <span 
                    className="post-menu-item post-menu-btn" 
                    onClick={() => setOpen(!open)}
                    style={{ cursor: "pointer", fontSize: "1.1rem", width: "26px", padding: "0", justifyContent: "center", textAlign: "center" }}
                > 
                    <i className="fas fa-ellipsis-v" /> 
                </span> 


            {open && (
                <div className="absolute dropdown-menu-post bg-black shadow-lg" style={{ minWidth: "180px", zIndex: 2000 }} onClick={(e) => e.stopPropagation()}>
                    <ul className="nav">
                    {isCommunityMod && (
                        <li className="dropdown-menu-item" style={{color:"white"}} onClick={handlePin}>
                        <div className="text-center d-inline-block" style={{width:"20px"}}><i className="fas fa-thumb-tack" /></div> 
                        {!pinLoading && (pinned ?"Unpin":"Pin")}
                        {pinLoading && <span className="spinner" />}
                        </li>
                    )}
                    {isCommunityMod && (
                        <li className="dropdown-menu-item" style={{color:"white"}} onClick={handleMute}>
                        <div className="text-center d-inline-block" style={{width:"20px"}}><i className="fas fa-eye-slash" /></div>
                        {!muteLoading && (muted ?"Unmute":"Mute")}
                        {muteLoading && <span className="spinner" />}
                        </li>
                    )}  
                    
                    <li className="dropdown-menu-item" style={{color:"white"}}>
                        <a href={`/${urlType}/${author}/${permlink}`} target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
                        <div className="text-center d-inline-block" style={{width:"20px", marginRight:"10px"}}><i className="fas fa-external-link" /></div>
                        Open in a new tab
                        </a>
                    </li>
                    <li className="dropdown-menu-item" style={{color:"white"}}>
                        <a href={`#`} target="_blank" rel="noopener noreferrer" style={{color:"white"}} onClick={(e) => {
                            e.preventDefault();
                            setOpen(false);
                            togglePlaylistsModal();
                        }}>
                        <div className="text-center d-inline-block" style={{width:"20px", marginRight:"10px"}}><i className="fas fa-list" /></div>
                        Add to a playlist
                        </a>
                    </li>
                    {!isExpired && (
                        <li className="dropdown-menu-item" style={{color:"white"}}>
                            <a href={`#`} target="_blank" rel="noopener noreferrer" style={{color:"white"}} onClick={(e) => {
                                e.preventDefault();
                                setOpen(false);
                                togglePromoteModal();
                            }}>
                                <div className="text-center d-inline-block" style={{width:"20px", marginRight:"10px"}}><i className="fas fa-rocket" /></div>
                                Promote
                            </a>
                        </li>
                    )}
                    
                    {canBeDeleted && (
                        <li className="dropdown-menu-item" style={{color:"white"}}>
                            <a href={`#`} target="_blank" rel="noopener noreferrer" style={{color:"white"}} onClick={(e) => {
                                e.preventDefault();
                                setOpen(false);
                                handleDeleteFromPlaylist();
                            }}>
                            <div className="text-center d-inline-block" style={{width:"20px", marginRight:"10px"}}><i className="fas fa-trash" /></div>
                            Remove from this playlist
                            </a>
                        </li>
                    )}
                    </ul> 
                </div>
            )}
            </div>
            <PlaylistsModal
                isShowing={isOpenPlaylistsModal}
                hide={togglePlaylistsModal}
                author={author}
                permlink={permlink}
            />
            <PromoteModal
                isShowing={isOpenPromoteModal}
                hide={togglePromoteModal}
                author={author}
                permlink={permlink}
            />
            <LoginModal
                isShowing={isOpenLoginModal}
                hide={toggleLoginModal}
                requiredActive={requiredActive}
                onSuccess={({ wif }) => {
                    // if (wif) {
                    // handleCreatePlaylist(wif);
                    // }
                    if (!wif || !pendingAction) return;

                    if (pendingAction.type === "remove") {
                        handleDeleteFromPlaylist(wif);
                    } 
                    setPendingAction(null); 
                }}
            />
        </>
    );
};

export default PostDropdown;
